/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmbedUrlV3Response } from '../models';
// @ts-ignore
import type { InventoryStatus } from '../models';
// @ts-ignore
import type { PaymentMethod } from '../models';
// @ts-ignore
import type { Provider } from '../models';
// @ts-ignore
import type { Theme } from '../models';
/**
 * MetabaseV3Api - axios parameter creator
 * @export
 */
export const MetabaseV3ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate embed URL for average sales dashboard
         * @summary Get Average Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageSales: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/average-sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Customer Insights Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {string} [customerName] Customer name to filter dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerInsights: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, customerName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/customer-insights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for latest orders dashboard
         * @summary Get Latest Orders Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestOrders: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/latest-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentMethod) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for Munchi online and kiosk sales dashboard
         * @summary Get Munchi Online and Kiosk Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<number>} [paymentMethodId] Payment method id to filter dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMunchiOnlineKioskSales: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethodId?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/munchi-online-kiosk-sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentMethodId) {
                localVarQueryParameter['paymentMethodId'] = paymentMethodId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for POS sales dashboard
         * @summary Get POS Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosSales: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, paymentMethod?: Array<PaymentMethod>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/pos-sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (paymentMethod) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for product inventory dashboard
         * @summary Get Product Inventory Dashboard
         * @param {string} [businessId] Business ID
         * @param {InventoryStatus} [inventoryStatus] Inventory status filter
         * @param {GetProductInventoryThemeEnum} [theme] Theme
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [ingredientName] Ingredient names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductInventory: async (businessId?: string, inventoryStatus?: InventoryStatus, theme?: GetProductInventoryThemeEnum, startDate?: string, endDate?: string, ingredientName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/product-inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (inventoryStatus !== undefined) {
                localVarQueryParameter['inventoryStatus'] = inventoryStatus;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (ingredientName !== undefined) {
                localVarQueryParameter['ingredientName'] = ingredientName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for products dashboard
         * @summary Get Products Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for sales overview dashboard
         * @summary Get Sales Overview Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOverview: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/sales-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentMethod) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for sales pressure dashboard
         * @summary Get Sales Pressure Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesPressure: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/sales-pressure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentMethod) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Staff Sales Dashboard
         * @param {string} [businessId] Business ID
         * @param {string} [startDate] Start date
         * @param {string} [endDate] End date
         * @param {string} [employeeId] Employee ID
         * @param {string} [userTimezone] User timezone
         * @param {GetStaffSalesThemeEnum} [theme] Theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffSales: async (businessId?: string, startDate?: string, endDate?: string, employeeId?: string, userTimezone?: string, theme?: GetStaffSalesThemeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/staff-sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employee_id'] = employeeId;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for status breakdown dashboard
         * @summary Get Status Breakdown Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusBreakdown: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/status-breakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentMethod) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for tax breakdown online and kiosk dashboard
         * @summary Get Tax Breakdown Online and Kiosk Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxBreakdownOnlineKiosk: async (businessId?: string, startDate?: string, endDate?: string, theme?: Theme, provider?: Array<Provider>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/tax-breakdown-online-kiosk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for tax breakdown POS dashboard
         * @summary Get Tax Breakdown POS Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {Theme} [theme] Dashboard theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxBreakdownPos: async (businessId?: string, startDate?: string, endDate?: string, theme?: Theme, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/tax-breakdown-pos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for total orders dashboard
         * @summary Get Total Orders Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalOrders: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/total-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentMethod) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate embed URL for total sales dashboard
         * @summary Get Total Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalSalesV3: async (businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/metabase/total-sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (userTimezone !== undefined) {
                localVarQueryParameter['userTimezone'] = userTimezone;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (paymentMethod) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetabaseV3Api - functional programming interface
 * @export
 */
export const MetabaseV3ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetabaseV3ApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate embed URL for average sales dashboard
         * @summary Get Average Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAverageSales(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAverageSales(businessId, startDate, endDate, userTimezone, theme, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getAverageSales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Customer Insights Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {string} [customerName] Customer name to filter dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerInsights(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, customerName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerInsights(businessId, startDate, endDate, userTimezone, theme, customerName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getCustomerInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for latest orders dashboard
         * @summary Get Latest Orders Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestOrders(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestOrders(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getLatestOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for Munchi online and kiosk sales dashboard
         * @summary Get Munchi Online and Kiosk Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<number>} [paymentMethodId] Payment method id to filter dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMunchiOnlineKioskSales(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethodId?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMunchiOnlineKioskSales(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethodId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getMunchiOnlineKioskSales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for POS sales dashboard
         * @summary Get POS Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPosSales(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPosSales(businessId, startDate, endDate, userTimezone, theme, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getPosSales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for product inventory dashboard
         * @summary Get Product Inventory Dashboard
         * @param {string} [businessId] Business ID
         * @param {InventoryStatus} [inventoryStatus] Inventory status filter
         * @param {GetProductInventoryThemeEnum} [theme] Theme
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [ingredientName] Ingredient names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductInventory(businessId?: string, inventoryStatus?: InventoryStatus, theme?: GetProductInventoryThemeEnum, startDate?: string, endDate?: string, ingredientName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductInventory(businessId, inventoryStatus, theme, startDate, endDate, ingredientName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getProductInventory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for products dashboard
         * @summary Get Products Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(businessId, startDate, endDate, userTimezone, theme, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for sales overview dashboard
         * @summary Get Sales Overview Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesOverview(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesOverview(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getSalesOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for sales pressure dashboard
         * @summary Get Sales Pressure Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesPressure(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesPressure(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getSalesPressure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Staff Sales Dashboard
         * @param {string} [businessId] Business ID
         * @param {string} [startDate] Start date
         * @param {string} [endDate] End date
         * @param {string} [employeeId] Employee ID
         * @param {string} [userTimezone] User timezone
         * @param {GetStaffSalesThemeEnum} [theme] Theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaffSales(businessId?: string, startDate?: string, endDate?: string, employeeId?: string, userTimezone?: string, theme?: GetStaffSalesThemeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaffSales(businessId, startDate, endDate, employeeId, userTimezone, theme, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getStaffSales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for status breakdown dashboard
         * @summary Get Status Breakdown Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatusBreakdown(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatusBreakdown(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getStatusBreakdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for tax breakdown online and kiosk dashboard
         * @summary Get Tax Breakdown Online and Kiosk Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxBreakdownOnlineKiosk(businessId?: string, startDate?: string, endDate?: string, theme?: Theme, provider?: Array<Provider>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxBreakdownOnlineKiosk(businessId, startDate, endDate, theme, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getTaxBreakdownOnlineKiosk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for tax breakdown POS dashboard
         * @summary Get Tax Breakdown POS Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {Theme} [theme] Dashboard theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxBreakdownPos(businessId?: string, startDate?: string, endDate?: string, theme?: Theme, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxBreakdownPos(businessId, startDate, endDate, theme, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getTaxBreakdownPos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for total orders dashboard
         * @summary Get Total Orders Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalOrders(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalOrders(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getTotalOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate embed URL for total sales dashboard
         * @summary Get Total Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalSalesV3(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedUrlV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalSalesV3(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetabaseV3Api.getTotalSalesV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetabaseV3Api - factory interface
 * @export
 */
export const MetabaseV3ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetabaseV3ApiFp(configuration)
    return {
        /**
         * Generate embed URL for average sales dashboard
         * @summary Get Average Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageSales(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getAverageSales(businessId, startDate, endDate, userTimezone, theme, provider, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Customer Insights Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {string} [customerName] Customer name to filter dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerInsights(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, customerName?: string, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getCustomerInsights(businessId, startDate, endDate, userTimezone, theme, customerName, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for latest orders dashboard
         * @summary Get Latest Orders Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestOrders(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getLatestOrders(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for Munchi online and kiosk sales dashboard
         * @summary Get Munchi Online and Kiosk Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<number>} [paymentMethodId] Payment method id to filter dashboard data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMunchiOnlineKioskSales(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethodId?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getMunchiOnlineKioskSales(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethodId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for POS sales dashboard
         * @summary Get POS Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosSales(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getPosSales(businessId, startDate, endDate, userTimezone, theme, paymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for product inventory dashboard
         * @summary Get Product Inventory Dashboard
         * @param {string} [businessId] Business ID
         * @param {InventoryStatus} [inventoryStatus] Inventory status filter
         * @param {GetProductInventoryThemeEnum} [theme] Theme
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [ingredientName] Ingredient names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductInventory(businessId?: string, inventoryStatus?: InventoryStatus, theme?: GetProductInventoryThemeEnum, startDate?: string, endDate?: string, ingredientName?: string, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getProductInventory(businessId, inventoryStatus, theme, startDate, endDate, ingredientName, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for products dashboard
         * @summary Get Products Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getProducts(businessId, startDate, endDate, userTimezone, theme, provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for sales overview dashboard
         * @summary Get Sales Overview Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOverview(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getSalesOverview(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for sales pressure dashboard
         * @summary Get Sales Pressure Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesPressure(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getSalesPressure(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Staff Sales Dashboard
         * @param {string} [businessId] Business ID
         * @param {string} [startDate] Start date
         * @param {string} [endDate] End date
         * @param {string} [employeeId] Employee ID
         * @param {string} [userTimezone] User timezone
         * @param {GetStaffSalesThemeEnum} [theme] Theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffSales(businessId?: string, startDate?: string, endDate?: string, employeeId?: string, userTimezone?: string, theme?: GetStaffSalesThemeEnum, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getStaffSales(businessId, startDate, endDate, employeeId, userTimezone, theme, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for status breakdown dashboard
         * @summary Get Status Breakdown Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusBreakdown(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getStatusBreakdown(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for tax breakdown online and kiosk dashboard
         * @summary Get Tax Breakdown Online and Kiosk Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxBreakdownOnlineKiosk(businessId?: string, startDate?: string, endDate?: string, theme?: Theme, provider?: Array<Provider>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getTaxBreakdownOnlineKiosk(businessId, startDate, endDate, theme, provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for tax breakdown POS dashboard
         * @summary Get Tax Breakdown POS Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {Theme} [theme] Dashboard theme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxBreakdownPos(businessId?: string, startDate?: string, endDate?: string, theme?: Theme, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getTaxBreakdownPos(businessId, startDate, endDate, theme, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for total orders dashboard
         * @summary Get Total Orders Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalOrders(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getTotalOrders(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate embed URL for total sales dashboard
         * @summary Get Total Sales Dashboard
         * @param {string} [businessId] Business ID to filter dashboard data
         * @param {string} [startDate] Start date/time for date range filter
         * @param {string} [endDate] End date/time for date range filter
         * @param {string} [userTimezone] User timezone (auto-detected from browser)
         * @param {Theme} [theme] Dashboard theme
         * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
         * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalSalesV3(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig): AxiosPromise<EmbedUrlV3Response> {
            return localVarFp.getTotalSalesV3(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetabaseV3Api - object-oriented interface
 * @export
 * @class MetabaseV3Api
 * @extends {BaseAPI}
 */
export class MetabaseV3Api extends BaseAPI {
    /**
     * Generate embed URL for average sales dashboard
     * @summary Get Average Sales Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getAverageSales(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getAverageSales(businessId, startDate, endDate, userTimezone, theme, provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Customer Insights Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {string} [customerName] Customer name to filter dashboard data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getCustomerInsights(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, customerName?: string, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getCustomerInsights(businessId, startDate, endDate, userTimezone, theme, customerName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for latest orders dashboard
     * @summary Get Latest Orders Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getLatestOrders(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getLatestOrders(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for Munchi online and kiosk sales dashboard
     * @summary Get Munchi Online and Kiosk Sales Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {Array<number>} [paymentMethodId] Payment method id to filter dashboard data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getMunchiOnlineKioskSales(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethodId?: Array<number>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getMunchiOnlineKioskSales(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for POS sales dashboard
     * @summary Get POS Sales Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getPosSales(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getPosSales(businessId, startDate, endDate, userTimezone, theme, paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for product inventory dashboard
     * @summary Get Product Inventory Dashboard
     * @param {string} [businessId] Business ID
     * @param {InventoryStatus} [inventoryStatus] Inventory status filter
     * @param {GetProductInventoryThemeEnum} [theme] Theme
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [ingredientName] Ingredient names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getProductInventory(businessId?: string, inventoryStatus?: InventoryStatus, theme?: GetProductInventoryThemeEnum, startDate?: string, endDate?: string, ingredientName?: string, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getProductInventory(businessId, inventoryStatus, theme, startDate, endDate, ingredientName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for products dashboard
     * @summary Get Products Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getProducts(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getProducts(businessId, startDate, endDate, userTimezone, theme, provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for sales overview dashboard
     * @summary Get Sales Overview Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getSalesOverview(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getSalesOverview(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for sales pressure dashboard
     * @summary Get Sales Pressure Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getSalesPressure(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getSalesPressure(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Staff Sales Dashboard
     * @param {string} [businessId] Business ID
     * @param {string} [startDate] Start date
     * @param {string} [endDate] End date
     * @param {string} [employeeId] Employee ID
     * @param {string} [userTimezone] User timezone
     * @param {GetStaffSalesThemeEnum} [theme] Theme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getStaffSales(businessId?: string, startDate?: string, endDate?: string, employeeId?: string, userTimezone?: string, theme?: GetStaffSalesThemeEnum, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getStaffSales(businessId, startDate, endDate, employeeId, userTimezone, theme, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for status breakdown dashboard
     * @summary Get Status Breakdown Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getStatusBreakdown(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getStatusBreakdown(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for tax breakdown online and kiosk dashboard
     * @summary Get Tax Breakdown Online and Kiosk Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getTaxBreakdownOnlineKiosk(businessId?: string, startDate?: string, endDate?: string, theme?: Theme, provider?: Array<Provider>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getTaxBreakdownOnlineKiosk(businessId, startDate, endDate, theme, provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for tax breakdown POS dashboard
     * @summary Get Tax Breakdown POS Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {Theme} [theme] Dashboard theme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getTaxBreakdownPos(businessId?: string, startDate?: string, endDate?: string, theme?: Theme, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getTaxBreakdownPos(businessId, startDate, endDate, theme, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for total orders dashboard
     * @summary Get Total Orders Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getTotalOrders(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getTotalOrders(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate embed URL for total sales dashboard
     * @summary Get Total Sales Dashboard
     * @param {string} [businessId] Business ID to filter dashboard data
     * @param {string} [startDate] Start date/time for date range filter
     * @param {string} [endDate] End date/time for date range filter
     * @param {string} [userTimezone] User timezone (auto-detected from browser)
     * @param {Theme} [theme] Dashboard theme
     * @param {Array<Provider>} [provider] Provider(s) to filter dashboard data. Use comma-separated values for multiple providers.
     * @param {Array<PaymentMethod>} [paymentMethod] Payment method(s) to filter dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseV3Api
     */
    public getTotalSalesV3(businessId?: string, startDate?: string, endDate?: string, userTimezone?: string, theme?: Theme, provider?: Array<Provider>, paymentMethod?: Array<PaymentMethod>, options?: RawAxiosRequestConfig) {
        return MetabaseV3ApiFp(this.configuration).getTotalSalesV3(businessId, startDate, endDate, userTimezone, theme, provider, paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetProductInventoryThemeEnum = {
    light: 'light',
    night: 'night'
} as const;
export type GetProductInventoryThemeEnum = typeof GetProductInventoryThemeEnum[keyof typeof GetProductInventoryThemeEnum];
/**
 * @export
 */
export const GetStaffSalesThemeEnum = {
    light: 'light',
    night: 'night'
} as const;
export type GetStaffSalesThemeEnum = typeof GetStaffSalesThemeEnum[keyof typeof GetStaffSalesThemeEnum];
